import type { PlaceUsage, ProducerUsage, ProducerKind } from '../types'

// The app opens these links as they are, so they must be complete addresses.
export function firstInvalidLink<T extends object>(fields: T, labels: Partial<Record<keyof T, string>>) {
  for (const [key, label] of Object.entries(labels) as [keyof T, string][]) {
    const value = String(fields[key] ?? '').trim()
    // A photo still previewed in the browser (blob:) becomes a Guve link on save.
    if (value && !value.startsWith('blob:') && !/^https?:\/\/\S+$/i.test(value)) return label
  }
  return ''
}

const plural = (count: number, one: string, many: string) => `${count} ${count === 1 ? one : many}`

// What keeps a place or producer from being deleted, or '' when nothing does.
export function usageSummary(usage: PlaceUsage | ProducerUsage) {
  const events = 'events' in usage ? usage.events : 0
  return [
    events && plural(events, 'evento', 'eventos'),
    usage.runs && plural(usage.runs, 'temporada de evento', 'temporadas de eventos'),
    usage.followers && plural(usage.followers, 'seguidor', 'seguidores'),
    usage.sources && plural(usage.sources, 'fonte de ingestão', 'fontes de ingestão'),
  ].filter(Boolean).join(', ')
}

export const KINDS: { value: ProducerKind; label: string }[] = [
  { value: 'producer', label: 'Produtor' },
  { value: 'venue', label: 'Local' },
  { value: 'artist', label: 'Artista' },
]

// The profile rules for the @, which producers share with the app's profiles.
export const normalizeHandle = (value: string) => value.trim().replace(/^@+/, '').toLowerCase()
export const validHandle = (handle: string) =>
  /^[a-z0-9._]{3,30}$/.test(handle) && /[a-z]/.test(handle) && !/^\.|\.$|\.\./.test(handle)
